import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 font-sans flex flex-col">
      <Navbar />
      <main className="flex-1 flex flex-col items-center justify-center text-center px-6">
        <h1 className="text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none leading-none">
          404
        </h1>
        <div className="relative z-10 -mt-8 md:-mt-12">
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950">
            Page Not Found
          </h2>
          <p className="mt-2 text-sm text-foreground-500 font-mono">
            {location.pathname}
          </p>
          <p className="mt-4 text-base text-foreground-500 max-w-md">
            The page you are looking for does not exist. Return to the homepage to explore PandabuySpreadsheet.
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 mt-6 px-7 py-3.5 bg-accent-500 text-white text-sm font-semibold rounded-full hover:bg-accent-600 transition-all cursor-pointer whitespace-nowrap group"
          >
            <i className="ri-arrow-left-line group-hover:-translate-x-1 transition-transform"></i>
            Back to Homepage
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}